import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Packaging } from "src/app/domain/models/Packaging";

@Injectable({providedIn: 'root'})
export abstract class PackagingGateway {
  abstract getAll(): Observable<Array<Packaging>>
}
